module.exports = __webpack_public_path__ + "static/media/dsc_logo.63f707f2.png";